import React from 'react';
import { resolveStyle } from './base_components';

require('../css/animations.less');

type Props = {
  style?: any;
  fraction: number;
};
export default class ProgressMeter extends React.PureComponent<Props> {
  render() {
    const { style, fraction } = this.props;
    const { className, inlineStyle } = resolveStyle(style, 'meter');
    const percent = (fraction * 100).toFixed(2);
    return (
      <div className={className} style={inlineStyle}>
        <span style={{ width: percent + '%' }} />
      </div>
    );
  }
}
